module.exports = __webpack_public_path__ + "static/media/scan-outline.961e7066.svg";